// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__FsywY","alert__header":"alert_alert__header__Dkyzs","cookiesAlert":"alert_cookiesAlert__JStWq"};